// Carries the surface that started a checkout across the hosted payment page,
// so the purchase event can be attributed to the paywall or pricing entry point.
const KEY = 'musicmint_checkout_source';
const MAX_AGE = 2 * 60 * 60 * 1000;

export function rememberCheckoutSource(source, productId, storage = globalThis.sessionStorage) {
  if (!storage || !source) return;
  try { storage.setItem(KEY, JSON.stringify({ source, product_id: productId || '', at: Date.now() })); }
  catch { /* Attribution is optional when storage is unavailable. */ }
}

export function readCheckoutSource(storage = globalThis.sessionStorage, now = Date.now()) {
  if (!storage) return null;
  try {
    const value = JSON.parse(storage.getItem(KEY) || 'null');
    if (!value || typeof value.source !== 'string' || now - Number(value.at) > MAX_AGE) return null;
    return { source: value.source, product_id: typeof value.product_id === 'string' ? value.product_id : '' };
  } catch { return null; }
}

export function clearCheckoutSource(storage = globalThis.sessionStorage) {
  try { storage?.removeItem(KEY); } catch { /* ignore */ }
}

// Songs a credit amount buys at the configured per-request cost; each request yields two versions.
export function songsForCredits(points, costPerRequest) {
  const credits = Number(points);
  const cost = Number(costPerRequest);
  if (!Number.isFinite(credits) || !Number.isFinite(cost) || credits <= 0 || cost <= 0) return 0;
  return Math.floor(credits / cost) * 2;
}

export function pricingPath(source) {
  return source ? `/pricing?from=${encodeURIComponent(source)}` : '/pricing';
}
